import React, { useEffect } from 'react'

export const Callback: React.FC = () => {
  useEffect(() => {
    const params = window.location.search

    if (window.opener) {
      window.opener.postMessage({ source: 'callback', params: params }, '*')
      window.onbeforeunload = onbeforeunload

      setTimeout(() => {
        window.close()
      }, 100)
    }
  }, [])

  const onbeforeunload = () => {
    if (window.opener && !window.opener.closed) {
      const doc = window.opener.document.getElementById('backdropLayout')
      if (doc) {
        doc.style.display = 'none'
      }
      window.opener.focus()
    }
  }
  return <p>Please wait...</p>
}
